import React, { useState } from 'react';
import { Mail, Phone, MapPin, ArrowRight, ShieldCheck, Heart } from 'lucide-react';
import { trackWhatsAppClick } from '../services/adminStorage';

export default function Footer({ onNavigate }) {
  const [showEmail, setShowEmail] = useState(false);

  const handleNav = (tab) => {
    onNavigate(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    trackWhatsAppClick();
    const text = encodeURIComponent('Olá! Gostaria de obter mais informações sobre as soluções da Suzume Technologies.');
    window.open(`https://wa.me/5511932654166?text=${text}`, '_blank');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Coluna 1: Branding */}
          <div>
            <img 
              src="/img/logo_suzume_horizontal.png" 
              alt="Suzume Technologies Logo" 
              className="footer-logo"
              style={{ filter: 'brightness(0) invert(1)' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/img/LogoSuzume.png';
              }} 
            />
            <p style={{ fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1.25rem', color: '#94a3b8' }}>
              A Suzume Technologies é especialista em acelerar presenças digitais de empresas e profissionais autônomos com um catálogo exclusivo de landing pages sob assinatura.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem', color: '#cbd5e1' }}>
              <ShieldCheck size={18} color="#10b981" />
              <span>Garantia de Qualidade &amp; Código Otimizado</span>
            </div>
          </div>

          {/* Coluna 2: Links Rápidos */}
          <div>
            <h4 className="footer-title">Navegação</h4>
            <ul className="footer-links">
              <li className="footer-link" onClick={() => handleNav('home')}>Página Inicial</li>
              <li className="footer-link" onClick={() => handleNav('catalog')}>Catálogo de Modelos</li>
              <li className="footer-link" onClick={() => {
                onNavigate('home');
                setTimeout(() => document.getElementById('pricing-section')?.scrollIntoView({ behavior: 'smooth' }), 100);
              }}>Planos de Assinatura</li>
              <li className="footer-link" onClick={() => {
                onNavigate('home');
                setTimeout(() => document.getElementById('reviews-section')?.scrollIntoView({ behavior: 'smooth' }), 100);
              }}>Avaliações</li>
              <li className="footer-link" onClick={() => {
                onNavigate('home');
                setTimeout(() => document.getElementById('faq-section')?.scrollIntoView({ behavior: 'smooth' }), 100);
              }}>Perguntas Frequentes</li>
              <li className="footer-link" onClick={() => handleNav('contact')}>Fale Conosco</li>
              <li className="footer-link" onClick={() => handleNav('admin')}>Painel Admin (/admin)</li>
            </ul>
          </div>

          {/* Coluna 4: Atendimento & Contato */}
          <div>
            <h4 className="footer-title">Atendimento Direto</h4>
            <ul className="footer-links" style={{ marginBottom: '1.25rem' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', fontSize: '0.9rem' }}>
                <Phone size={16} color="#3a86ff" />
                <span>(11) 93265-4166</span>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', fontSize: '0.9rem' }}>
                <Mail size={16} color="#3a86ff" />
                {showEmail ? (
                  <a href="mailto:contato@suzumetech.com.br" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                    contato@suzumetech.com.br
                  </a>
                ) : (
                  <button 
                    onClick={() => setShowEmail(true)} 
                    style={{ 
                      background: 'rgba(58, 134, 255, 0.15)', 
                      border: '1px solid rgba(58, 134, 255, 0.3)', 
                      color: '#3a86ff', 
                      borderRadius: '6px', 
                      padding: '0.2rem 0.6rem', 
                      fontSize: '0.8rem', 
                      cursor: 'pointer',
                      fontWeight: 600,
                      transition: 'all 0.2s ease'
                    }}
                  >
                    Ver e-mail
                  </button>
                )}
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', fontSize: '0.9rem' }}>
                <MapPin size={16} color="#3a86ff" />
                <span>São Paulo, SP - Brasil</span>
              </li>
            </ul>
            <button className="btn btn-whatsapp btn-sm" onClick={openWhatsApp} style={{ width: '100%' }}>
              Solicitar Orçamento no WhatsApp
              <ArrowRight size={16} />
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Suzume Technologies. Todos os direitos reservados.</p>
          <p style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
            Desenvolvido com <Heart size={14} color="#ef4444" fill="#ef4444" /> para alta conversão.
          </p>
        </div>
      </div>
    </footer>
  );
}
